/** Segment `deposit_method` for the v2 screen — distinct from legacy 'Crypto' (D-SEG). */
export const CRYPTO_DIRECT_DEPOSIT_METHOD = 'Crypto Direct';

/** Display names for Whop network families / chains. Proper nouns — not translated. Unknown keys fall back to the raw value. */
export const CRYPTO_NETWORK_LABELS: Record<string, string> = {
  evm: 'Ethereum & EVM',
  ethereum: 'Ethereum',
  base: 'Base',
  arbitrum: 'Arbitrum',
  optimism: 'Optimism',
  polygon: 'Polygon',
  solana: 'Solana',
  bitcoin: 'Bitcoin',
  tron: 'Tron',
  hypercore: 'Hypercore',
};

export const getNetworkLabel = (key: string) => CRYPTO_NETWORK_LABELS[key.toLowerCase()] ?? key;

/** Bounded "setting up" retry cycle for the address sheet (task B5). A confirm that lands on a
 *  `provisioning` account re-fires the create call from `onSettled`, up to this many times, before
 *  giving up and showing the settingUpTimeout copy. NEVER a bare `setInterval` — always armed from
 *  the settled callback so at most one create call is ever in flight. */
export const CRYPTO_SETUP_RETRY_MS = 5_000;
export const CRYPTO_SETUP_MAX_RETRIES = 6;

/** Overall wall-clock ceiling on the setting-up cycle, anchored at ENTRY to settingUp — NOT at
 *  sheet open, NOT at the first create request — so a slow initial `loading` request never eats the
 *  polling budget. On expiry the cycle aborts any in-flight poll (AbortController) and transitions to
 *  `settingUpTimeout` (Retry, lock released), regardless of attempt count. The 6×5s attempt schedule
 *  (30s) runs inside this ceiling. */
export const CRYPTO_SETUP_DEADLINE_MS = 60_000;

/** Per-request client timeout on the create/poll POST. 40s = gateway RxJS timeout (35s→504) + margin;
 *  a hung request below the gateway rejects here so the loading/settingUp lock is always bounded
 *  (a11y 2.1.2). Scoped to the create call (the locked cycle's request) — NOT set on the shared
 *  `walletServiceInstance` (blast radius) and NOT on the container GET (not in a locked modal). A
 *  timeout rejects (ECONNABORTED, no `.response`) → not a CryptoCooldownError → the existing catch
 *  rethrows → `mutation.isError` → `phase 'error'` (unlocked, Retry visible). */
export const CRYPTO_CREATE_TIMEOUT_MS = 40_000;

/** EDGE-32497 (design §2.3): after a deposit address rotation the sheet shows "your address was
 *  updated on {{date}}; a previous address still works" for this many days. Address-free copy
 *  because more than one prior address may exist. */
export const CRYPTO_ADDRESS_CHANGED_NOTICE_DAYS = 30;
